import { render } from "./PageHero.vue?vue&type=template&id=5f84ba82&scoped=true&ts=true&lang=html"
import script from "./PageHero.vue?vue&type=script&lang=ts"
export * from "./PageHero.vue?vue&type=script&lang=ts"

import "./PageHero.vue?vue&type=style&index=0&id=5f84ba82&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f84ba82"]])

export default __exports__